import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';

import swal from 'sweetalert2';
import * as shortid from 'shortid';

@Component({
  selector: 'app-video-upload-btn',
  templateUrl: './video-upload-btn.component.html',
  styleUrls: ['./video-upload-btn.component.css']
})
export class VideoUploadBtnComponent implements OnInit, AfterViewChecked {

  @ViewChild('closeLinkUploadModal') public closeLinkUploadModal: ElementRef;

  @Input() onlyFile = false;

  @Output() fileUpload = new EventEmitter();
  @Output() linkUpload = new EventEmitter();

  public data = {
    name: '',
    link: ''
  };
  public uniqueId = shortid.generate();

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    $('#linkUploadModal-' + this.uniqueId).on('hidden.bs.modal', () => {
      this.data = {
        name: '',
        link: ''
      }
    })
  }

  onFileUpload(event) {
    this.fileUpload.emit(event);
  }

  onLinkUpload() {
    if (!this.data.name || !this.data.link) {
      swal('Warning', 'Please fill all the fields', 'warning');
      return;
    }

    let validUrl = null;
    try {
      const url = new URL(this.data.link);
      console.log(url);
      validUrl = url.href;
    } catch (err) { validUrl = null; }
    if (!validUrl) {
      swal('Warning', 'Please enter a valid URL', 'warning');
      return;
    }
    this.linkUpload.emit({
      name: this.data.name,
      path: validUrl,
      enc_name: null,
      extension: null
    });
    this.closeLinkUploadModal.nativeElement.click();
  }

}



// WEBPACK FOOTER //
// G:/UTL/Teacher/Teacher-ANG/src/app/shared/video-upload-btn/video-upload-btn.component.ts